import Grid from 'UIKit/Box/Grid'
import Text from 'UIKit/Text'
import styled from 'styled-components'

export const BonusContentGridSystem = styled(Grid)`
  grid-template-columns: repeat(2, 36% 64%);
  align-items: center;
`

export const BonusContentFieldTitle = styled(Text)`
  color: ${({ theme: { colors } }) => colors.textSubtle};
  font-size: 12px;
  line-height: normal;
  letter-spacing: -0.24;
  font-weight: 400;
`
